import React, { useState } from "react";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2, Calendar } from "lucide-react";
import { HOME } from "@/constants/testIds";

export default function Cta() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) return;
    setSent(true);
    // Hand-off intent — would post to backend when wired
    setTimeout(() => setSent(false), 4000);
    setEmail("");
  };

  return (
    <section className="relative py-32">
      <div className="aurora-orb bg-[#0047FF] w-[700px] h-[700px] left-1/2 -translate-x-1/2 top-0 opacity-30" />
      <div className="container-x relative">
        <div className="relative overflow-hidden rounded-[2.5rem] glass-strong p-10 md:p-20">
          <div className="absolute -top-32 -right-32 w-[400px] h-[400px] bg-gradient-to-br from-[#0047FF]/30 to-[#00F0FF]/20 rounded-full blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] bg-gradient-to-br from-[#8A2BE2]/30 to-[#0047FF]/20 rounded-full blur-3xl pointer-events-none" />

          <div className="relative z-10 max-w-3xl">
            <h2 className="font-display text-4xl md:text-6xl font-bold leading-[1.05] mb-6">
              Ready to{" "}
              <span className="aurora-text">Boost Your Revenue?</span>
            </h2>
            <p className="text-white/70 text-lg mb-10 max-w-2xl">
              Join hundreds of publishers already maximizing their advertising
              potential with MonetiseUP's advanced platform. Subscribe for
              insights, product updates, and revenue benchmarks.
            </p>

            <form
              onSubmit={submit}
              className="flex flex-col sm:flex-row gap-3 max-w-xl"
            >
              <input
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid={HOME.newsletterInput}
                className="flex-1 px-5 py-4 rounded-full bg-white/5 border border-white/10 focus:border-[#00F0FF]/50 focus:outline-none text-white placeholder:text-white/30"
                aria-label="Email address"
              />
              <button
                type="submit"
                data-testid={HOME.newsletterSubmit}
                className="btn-primary justify-center"
              >
                {sent ? (
                  <>
                    <CheckCircle2 className="w-4 h-4" /> Subscribed
                  </>
                ) : (
                  <>
                    Join <ArrowRight className="w-4 h-4" />
                  </>
                )}
              </button>
            </form>

            <div className="mt-10 flex flex-wrap gap-4 items-center">
              <a
                href="mailto:contact@monetiseup.com?subject=Schedule%20Demo"
                data-testid={HOME.scheduleDemoBtn}
                className="btn-ghost"
              >
                <Calendar className="w-4 h-4" /> Schedule Demo
              </a>
              <a
                href="/demo"
                className="text-sm text-white/60 hover:text-white"
              >
                or explore the live format showcase →
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
